import React from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { BtnSubmit } from '../inputs/btnSubmit';
import InputText from '../inputs/inputText';
import BaseComponent from '../baseComponent';
import IFormError from '../forms/IFormError';
import { filter } from 'lodash';
import IMenuItem from '../../interfaces/IMenuItem';
import IMenu from '../../interfaces/IMenu';
import InputUrl from '../inputs/inputUrl';
import { MenuItemType } from '../../enums/menuItemType';

interface IState {
    loading: boolean,
    item: IMenuItem,
    serverErrors: IFormError[]
}

interface IProps {
    menu: IMenu
}

export default class CreateMenuItemUserLinkCard extends BaseComponent<IProps, IState> {

    private inputUrl: React.RefObject<InputUrl>;
    private inputName: React.RefObject<InputText>;

    constructor(props: IProps) {
        super(props);

        this.state = {
            loading: false,
            item: {
                type: MenuItemType.UserLink,
                menuId: this.props.menu.id,
                name: '',
                categoryId: '',
                id: '',
                index: 0,
                pageId: '',
                parentMenuItemId: '',
                sectionId: '',
                url: ''
            },
            serverErrors: []
        }

        this.inputUrl = React.createRef();
        this.inputName = React.createRef();
    }

    handleChange(value: any, key: string) {
        this.setState({
            item: {
                ...this.state.item,
                [key]: value
            },
            serverErrors: filter(this.state.serverErrors, error => { if (error.key !== key) return true; else return false })
        })
    }


    handleSubmit() {
        const inputs = [
            this.inputName,
            this.inputUrl,
        ]

        const isValid = this.validateInputs(inputs);

        if (isValid) {
            const { item } = this.state;
            const { menu } = this.props;

            this.setState({
                loading: true
            })

            this.menusApiService.createMenuItem(menu.id, item)
                .then(data => {
                    if (data.success) {
                        this.setState({
                            loading: false,
                            item: {
                                ...this.state.item,
                                name: '',
                                url: ''
                            }
                        })
                    }
                    else {
                        this.setState({
                            serverErrors: data.formErrors,
                            loading: false,
                        })
                        this.validateInputs(inputs);
                    }
                })
        }
    }

    render() {
        const { loading, item } = this.state;

        return (
            <Card className="mb-0 pb-0">
                <Accordion.Toggle as={Card.Header} className="clickable text-purple" eventKey="customLink">
                    Uživatelské odkazy <i className="fas fa-angle-down float-right mt-1"></i>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey="customLink">
                    <Card.Body>
                        <InputText
                            uid="name"
                            ref={this.inputName}
                            label="Text odkazu"
                            value={item.name}
                            onChange={this.handleChange.bind(this)}
                            required
                        />

                        <InputUrl
                            uid="url"
                            ref={this.inputUrl}
                            label="Odkaz"
                            onChange={this.handleChange.bind(this)}
                            value={item.url}
                            required
                            onEnter={this.handleSubmit.bind(this)}
                        />

                        <BtnSubmit
                            className="btn btn-outline-primary float-right mb-3"
                            loading={loading}
                            onClick={this.handleSubmit.bind(this)}
                        >
                            Přidat do menu
                        </BtnSubmit>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        )
    }
}